let authExpiryRedirectInFlight = false

export function clearAuthSessionStorage() {
  localStorage.removeItem('authToken')
  localStorage.removeItem('user')
  sessionStorage.removeItem('agentPort')
  sessionStorage.removeItem('sessionId')
  localStorage.removeItem('sip_device_on')
  try {
    const keysToRemove = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith('sip_device_on_')) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k))
  } catch (_) {}
}

function buildLoginRedirectUrl(reasonCode) {
  const isSelfService =
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/self-service')
  const base = isSelfService ? '/self-service/login' : '/login'
  const normalized = String(reasonCode || '').trim().toUpperCase()
  if (!normalized) return base
  if (normalized === 'SESSION_REPLACED') return `${base}?reason=session-replaced`
  if (normalized === 'NO_SESSION') return `${base}?reason=no-session`
  return base
}

export function handleExpiredAuthSession(reasonCode = null) {
  clearAuthSessionStorage()
  const detail = reasonCode ? { reasonCode: String(reasonCode).toUpperCase() } : null
  window.dispatchEvent(new CustomEvent('auth-expired', { detail }))

  if (authExpiryRedirectInFlight) return
  authExpiryRedirectInFlight = true

  const pathname = typeof window !== 'undefined' ? window.location.pathname : ''
  const isSelfService = pathname.startsWith('/self-service')
  const target = buildLoginRedirectUrl(reasonCode)

  if (isSelfService) {
    if (pathname !== '/self-service/login') {
      window.location.replace(target)
      return
    }
  } else {
    if (!pathname.startsWith('/login')) {
      window.location.replace(target)
      return
    }
  }

  authExpiryRedirectInFlight = false
}
